import moment from "moment";
import React, { useEffect, useState } from "react";
import CommonDatePicker from "../DatePicker/CommonDatePicker";

const ReportDate = (props, callback) => {
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  console.log(props, "propspropsprops");

  const handleStartDateChange = (event) => {
    console.log(event, "checktimehere");
    const settime = moment(event).format("YYYY-MM-DD");
    console.log(settime, "event check");
    if (props.selectReport === 2) {
      setStartingDate(settime);
    }
  };
  const handleEndDateChange = (event) => {
    const settime = moment(event).format("YYYY-MM-DD");
    console.log(settime, "event check");
    if (props.selectReport === 2) {
      setEndingDate(settime);
    }
  };

  useEffect(
    (momentDate) => {
      if (props.selectReport == 4) {
        // This Week
        const startOfWeek = moment().startOf("week");
        const endOfWeek = moment(startOfWeek).add(6, "days");
        setStartingDate(startOfWeek.format("YYYY-MM-DD"));
        setEndingDate(endOfWeek.format("YYYY-MM-DD"));
      } else if (props.selectReport == 5) {
        // This Week to Today
        const endDate = moment();
        const startDate = moment().startOf("week");
        setStartingDate(startDate.format("YYYY-MM-DD"));
        setEndingDate(endDate.format("YYYY-MM-DD"));
      } else if (props.selectReport == 6) {
        // This Month
        const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
        const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
        setStartingDate(startOfMonth);
        setEndingDate(endOfMonth);
      } else if (props.selectReport == 7) {
        // This Month to Today
        const startDate = moment().startOf("month"); // First day of this month
        const endDate = moment(); // Today
        setStartingDate(startDate.format("YYYY-MM-DD"));
        setEndingDate(endDate.format("YYYY-MM-DD"));
      } else if (props.selectReport == 8) {
        // This Quarter
        const currentDate = moment();
        const quarter = currentDate.quarter();
        const startOfQuarter = moment().quarter(quarter).startOf("quarter");
        const endOfQuarter = moment().quarter(quarter).endOf("quarter");
        setStartingDate(startOfQuarter.format("YYYY-MM-DD"));
        setEndingDate(endOfQuarter.format("YYYY-MM-DD"));
      } else if (props.selectReport == 9) {
        // This Quarter to Today
        const currentDate = moment();
        const quarter = currentDate.quarter();
        // Start of the current quarter
        const startOfQuarter = moment().quarter(quarter).startOf("quarter");
        // End date is today
        const endDate = moment();
        setStartingDate(startOfQuarter.format("YYYY-MM-DD"));
        setEndingDate(endDate.format("YYYY-MM-DD"));
      } else if (props.selectReport == 10) {
        // This Year
        const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
        const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
        setStartingDate(startOfYear);
        setEndingDate(endOfYear);
      } else if (props.selectReport == 11) {
        // This Year to Today
        const startOfYear = moment().startOf("year");
        const endDate = moment(); // today
        setStartingDate(startOfYear.format("YYYY-MM-DD"));
        setEndingDate(endDate.format("YYYY-MM-DD"));
      } else if (props.selectReport == 12) {
        // This Year to Last Month
        const firstDayOfYear = moment().startOf("year");
        const lastDayOfPreviousMonth = moment()
          .subtract(1, "month")
          .endOf("month");
        setStartingDate(firstDayOfYear.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfPreviousMonth.format("YYYY-MM-DD"));
      } else if (props.selectReport == 13) {
        // Yesterday
        const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
        console.log(yesterday, "yesterday");

        setStartingDate(yesterday);
        setEndingDate(yesterday);
      } else if (props.selectReport == 14) {
        // recent
        const recentDate = moment().format("YYYY-MM-DD");
        setStartingDate(recentDate);
        setEndingDate(recentDate);
      } else if (props.selectReport == 15) {
        // Last Week
        const lastWeekStart = moment()
          .subtract(1, "week")
          .startOf("week")
          .format("YYYY-MM-DD"); // Start of last week
        const lastWeekEnd = moment()
          .subtract(1, "week")
          .endOf("week")
          .format("YYYY-MM-DD"); // End of last week
        setStartingDate(lastWeekStart);
        setEndingDate(lastWeekEnd);
      } else if (props.selectReport == 16) {
        // Last Week to Today
        const lastWeekStart = moment()
          .subtract(1, "week")
          .startOf("week")
          .format("YYYY-MM-DD"); // Start of last week
        const today = moment().format("YYYY-MM-DD"); // Today
        setStartingDate(lastWeekStart);
        setEndingDate(today);
      } else if (props.selectReport == 17) {
        // Last Month
        const firstDayOfLastMonth = moment()
          .subtract(1, "month")
          .startOf("month");
        const lastDayOfLastMonth = moment().subtract(1, "month").endOf("month");
        setStartingDate(firstDayOfLastMonth.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfLastMonth.format("YYYY-MM-DD"));
      } else if (props.selectReport == 18) {
        // Last Month to Today
        const firstDayOfLastMonth = moment()
          .subtract(1, "month")
          .startOf("month");
        const today = moment(); // Today
        setStartingDate(firstDayOfLastMonth.format("YYYY-MM-DD"));
        setEndingDate(today.format("YYYY-MM-DD"));
      } else if (props.selectReport == 19) {
        // Previous Quarter
        const currentDate = moment();
        const currentQuarter = currentDate.quarter();
        const previousQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
        // Start of the previous quarter
        const startOfPreviousQuarter = moment()
          .quarter(previousQuarter)
          .startOf("quarter");
        // End of the previous quarter
        const endOfPreviousQuarter = moment()
          .quarter(previousQuarter)
          .endOf("quarter");
        setStartingDate(startOfPreviousQuarter.format("YYYY-MM-DD"));
        setEndingDate(endOfPreviousQuarter.format("YYYY-MM-DD"));
      } else if (props.selectReport == 20) {
        // Previous Quarter to Today
        const currentDate = moment();
        const currentQuarter = currentDate.quarter();
        const previousQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
        // Start of the previous quarter
        const startOfPreviousQuarter = moment()
          .quarter(previousQuarter)
          .startOf("quarter");
        // End date is today
        const endDate = moment();
        setStartingDate(startOfPreviousQuarter.format("YYYY-MM-DD"));
        setEndingDate(endDate.format("YYYY-MM-DD"));
      } else if (props.selectReport == 21) {
        // Previous Year
        const firstDayOfPreviousYear = moment()
          .subtract(1, "year")
          .startOf("year");
        const lastDayOfPreviousYear = moment()
          .subtract(1, "year")
          .endOf("year");
        setStartingDate(firstDayOfPreviousYear.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfPreviousYear.format("YYYY-MM-DD"));
      } else if (props.selectReport == 22) {
        // Previous Year to Today
        const firstDayOfPreviousYear = moment()
          .subtract(1, "year")
          .startOf("year");
        const today = moment(); // Today
        setStartingDate(firstDayOfPreviousYear.format("YYYY-MM-DD"));
        setEndingDate(today.format("YYYY-MM-DD"));
      } else if (props.selectReport == 23) {
        // Last 30 Days
        const last30DaysStart = moment().subtract(30, "days").startOf("day");
        const last30DaysEnd = moment().endOf("day");
        setStartingDate(last30DaysStart.format("YYYY-MM-DD"));
        setEndingDate(last30DaysEnd.format("YYYY-MM-DD"));
      } else if (props.selectReport == 24) {
        // 60 days ago
        const firstDayOfLast60Days = moment()
          .subtract(60, "days")
          .startOf("day");
        const lastDayOfLast60Days = moment().endOf("day");
        setStartingDate(firstDayOfLast60Days.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfLast60Days.format("YYYY-MM-DD"));
      } else if (props.selectReport == 25) {
        // 90 days ago
        const firstDayOfLast90Days = moment()
          .subtract(90, "days")
          .startOf("day");
        const lastDayOfLast90Days = moment().endOf("day");
        setStartingDate(firstDayOfLast90Days.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfLast90Days.format("YYYY-MM-DD"));
      } else if (props.selectReport == 26) {
        // 365 days ago
        const firstDayOfLast365Days = moment()
          .subtract(365, "days")
          .startOf("day");
        const lastDayOfLast365Days = moment().endOf("day");
        setStartingDate(firstDayOfLast365Days.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfLast365Days.format("YYYY-MM-DD"));
      } else if (props.selectReport == 27) {
        // Next Week
        const firstDayOfNextWeek = moment().add(1, "week").startOf("week"); // Start of next week
        const lastDayOfNextWeek = moment().add(1, "week").endOf("week"); // End of next week
        setStartingDate(firstDayOfNextWeek.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfNextWeek.format("YYYY-MM-DD"));
      } else if (props.selectReport == 28) {
        // Next 4 weeks
        const firstDayOfNext4Weeks = moment().add(1, "week").startOf("week"); // Next Monday
        const lastDayOfNext4Weeks = moment(firstDayOfNext4Weeks)
          .add(27, "days")
          .endOf("day"); // 4 full weeks

        setStartingDate(firstDayOfNext4Weeks.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfNext4Weeks.format("YYYY-MM-DD"));
      } else if (props.selectReport == 29) {
        // Next Month
        // Calculate the first and last day of the next month
        const firstDayOfNextMonth = moment().add(1, "month").startOf("month");
        const lastDayOfNextMonth = moment().add(1, "month").endOf("month");
        setStartingDate(firstDayOfNextMonth.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfNextMonth.format("YYYY-MM-DD"));
      } else if (props.selectReport == 30) {
        // Next Quarter
        const firstDayOfNextQuarter = moment()
          .add(1, "quarter")
          .startOf("quarter");
        const lastDayOfNextQuarter = moment()
          .add(1, "quarter")
          .endOf("quarter");
        setStartingDate(firstDayOfNextQuarter.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfNextQuarter.format("YYYY-MM-DD"));
      } else if (props.selectReport == 31) {
        // Next Year
        const firstDayOfNextYear = moment().add(1, "year").startOf("year");
        const lastDayOfNextYear = moment().add(1, "year").endOf("year");
        setStartingDate(firstDayOfNextYear.format("YYYY-MM-DD"));
        setEndingDate(lastDayOfNextYear.format("YYYY-MM-DD"));
      } else if (props.selectReport == 3) {
        // Custom Date
        setStartingDate(moment(momentDate).format("YYYY-MM-DD"));
        setEndingDate(moment(momentDate).format("YYYY-MM-DD"));
      } else {
        setStartingDate("");
        setEndingDate("");
      }
    },
    [props.selectReport]
  );

  useEffect(() => {
    props.callback(startingDate, endingDate);
  }, [startingDate, endingDate]);

  return (
    <>
      {props.showhidecomponent && (
        <>
          {props.showasofdate ? (
            <div className="row col-sm-12">
            <div className="col-sm-12 z-5">
              <label className="col-form-label form-label custom-search-select">
                As of
              </label>
              <CommonDatePicker
                FinalDate={endingDate}
                // handleDateChange={handleChangeCustomEndingDate}
                handleDateChange={(e) => handleEndDateChange(e)}
                disabled={props.selectReport !== 2}
              />
            </div>
            </div>
          ) : (
            <div className="row col-sm-12">
              <div className="col-sm-6 z-5">
                <label className="col-form-label form-label custom-search-select">
                  Start Date
                </label>
                <CommonDatePicker
                  FinalDate={startingDate}
                  handleDateChange={(e) => handleStartDateChange(e)}
                  disabled={props.selectReport !== 2}
                />
              </div>
              <div className="col-sm-6 z-5">
                <label className="col-form-label form-label custom-search-select">
                  End Date
                </label>
                <CommonDatePicker
                  FinalDate={endingDate}
                  // handleDateChange={handleChangeCustomEndingDate}
                  handleDateChange={(e) => handleEndDateChange(e)}
                  disabled={props.selectReport !== 2}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ReportDate;
